package net.maraclinic.app.theme

import org.jetbrains.compose.web.css.cssRem

object Breakpoints {
    val ExtraSmall = 48.cssRem
    val Small = 76.8.cssRem
    val Medium = 99.2.cssRem
    val Large = 128.cssRem
    val ExtraLarge = 153.6.cssRem
}